import type {
    AnimationEditionInput,
    AnimationId,
    AnimationSummary,
} from '@wwf/sdk';
import { RAFile } from '../types';

export interface AnimationInput extends AnimationEditionInput {
    id?: AnimationId;
    imageInput?: RAFile;
}

export function animationSummaryToInput(
    summary: AnimationSummary
): AnimationInput {
    const {
        image,
        createdAt,
        updatedAt,
        organizationId,
        inventoryCount,
        inventoryComment,
        available,
        ...edition
    } = summary;

    return {
        ...edition,
        imageId: image?.id ?? null,
    };
}
